import { Table } from 'antd';
import { Table as TableV5 } from 'antd-v5';
import styled, { css } from 'styled-components';
import { theme } from 'styles';
import { Flex, Input, Text } from 'UI';

export const FluidHeader = styled.div`
  background-color: ${theme.color.grey95};
  height: 54px;
  width: 100%;
`;

const tableCss = css`
  flex: 1;

  thead > tr > th {
    text-align: center !important;
    background-color: ${theme.color.grey95_light};
  }

  tbody > tr:last-child > td:last-child.ant5-table-cell {
    border-bottom-right-radius: 8px;
  }

  tbody > tr:last-child > td:first-child.ant5-table-cell,
  .ant5-table-container {
    border-bottom-left-radius: 8px;
  }
`;

export const printCss = css`
  @page {
    size: portrait;
    margin: 5mm 4mm 10mm 4mm;
  }

  @media print {
    @page {
      @bottom-right {
        content: counter(page);
      }
      @bottom-left, @bottom-center {
        content: '';
      }
    }

    html,
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }

    thead {
      display: table-row-group !important;
    }

    table {
      font-size: 10pt;
    }

    //decreases chance to overlap content on page break
    .ant5-table {
      margin-bottom: 10px !important;
    }

    th.ant5-table-cell {
      padding: 2px !important;
    }

    td.ant5-table-cell {
      padding: 2px !important;
    }
  }
`;

export const MileageIntervalTable = styled(TableV5)`
  ${tableCss};

  .ant5-table-cell-row-hover {
    background-color: inherit !important;
    color: inherit !important;
  }

  .highlight-operation-year-column {
    background-color: ${theme.color.blue_dark_3} !important;
    color: ${theme.color.white} !important;
  }

  .highlight-operation-year-column > span {
    color: ${theme.color.white} !important;
  }

  .ant5-table-cell:has(.highlight-operation-label-cell) {
    background-color: ${theme.color.blue_dark_3} !important;
    color: ${theme.color.white} !important;
  }
` as typeof TableV5;

export const OperationTable = styled(TableV5)`
  ${tableCss};
  max-height: fit-content;
` as typeof TableV5;

export const EngineTable = styled(Table)`
  ${tableCss};

  thead > tr > th {
    padding: 10px;
  }
` as typeof Table;

export const SFlex = styled(Flex)`
  padding: 10px;
`;

export const RotatedText = styled(Text)`
  writing-mode: vertical-lr;
  transform: rotate(360deg);
`;

export const SFlexMileage = styled(Flex)`
  background-color: ${theme.color.grey95_light};
  width: fit-content;
  border: 1px solid ${theme.color.grey85};
  border-radius: 8px;
`;

export const SInput = styled(Input)<{ isHighlighted?: boolean }>`
  height: 40px;
  width: 200px;
  border-color: ${({ isHighlighted }) => (isHighlighted ? theme.color.red : null)};
`;
